import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const GameInfoComponent = React.lazy(() => import("../Components/RootComponents/GameInfoComponent"));
const GameInfoPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <GameInfoComponent />
      </Suspense>
    </Fragment>
  );
};

export default GameInfoPage;
